import {atom} from 'jotai'
import {ListFilter, MarketList, Product} from '../domain'

const detail: Product = {
  productId: '',
  name: '',
  description: '',
  price: 0,
  image: '',
}

export const detailAtom = atom<Product>(detail)

const list: MarketList = {
  dataList: [],
  paging: {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  },
}

export const listAtom = atom<MarketList>(list)

export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  orderList: [],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})
